module.exports = __webpack_public_path__ + "img/arpita.1c687f08.jpg";